export const enum LocalStorageKey {
  AUTH_USER = 'ev.auth.user',
  CAPTCHA_SITE_KEY = 'ev.front-end.env.captcha_site_key',
  WIDGET_STATE = 'ev.stats.widgetState',
  WEB_DATA_ROCKS = 'webDataRocksSettings',
}
